/* eslint-disable */
import React from "react";
import cookie from "react-cookies";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { apiUrl, headerconfig } from "./Config";
import $ from "jquery";
import Axios from "axios";
var qs = require("qs");
var base64 = require("base-64");

/* stripslashes  */
export const stripslashes = function (str) {
  if (str !== "" && typeof str !== undefined && typeof str !== "undefined") {
    str = str.replace(/\\'/g, "'");
    str = str.replace(/\\"/g, '"');
    str = str.replace(/\\0/g, "\0");
    str = str.replace(/\\\\/g, "\\");
    return str;
  }
};

/* show Alert */
export const showAlert = function (header, message, type) {
  var icon = "";
  if (type === "success") {
    icon = "success";
  } else if (type === "success") {
    icon = "warning";
  } else {
    icon = "error";
  }
  Swal.fire({
    title: header,
    html: message,
    icon: icon,
    customClass: {
      confirmButton: "btn btn-primary waves-effect waves-light",
    },
    buttonsStyling: false,
  });
};

/* show Loader */
export const showLoader = function (divRef, type) {
  if (type === "class") {
    $("." + divRef)
      .addClass("loader-main-cls")
      .append(
        '<span class="spinner-border spinner-border-sm loader-sub" role="status" aria-hidden="true"></span>'
      );
  } else {
    $("#" + divRef)
      .addClass("loader-main-cls")
      .append(
        '<span class="spinner-border spinner-border-sm loader-sub" role="status" aria-hidden="true"></span>'
      );
  }
};
export const showContaimerLoader = function () {
  return (
    <div className="spinner2">
      <div className="cube1"></div>
      <div className="cube2"></div>
    </div>
  );
};

/* hide Loader */
export const hideLoader = function (divRef, type) {
  if (type === "class") {
    $("." + divRef).removeClass("loader-main-cls");
    $("." + divRef)
      .find(".loader-sub")
      .remove();
  } else {
    $("#" + divRef).removeClass("loader-main-cls");
    $("#" + divRef)
      .find(".loader-sub")
      .remove();
  }
};

/* sample funtion */
export const showPriceValue = function (price) {
  if (price !== "") {
    if (parseFloat(price) >= 0) {
      return (
        <>
          <i className="fa fa-inr" aria-hidden="true"></i>
          {parseFloat(price)
            .toFixed("2")
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        </>
      );
    }
  }
};

export const showPrecentage = function (price, digit=0) {
  if(price!=="") {
    var newPrice = String(price);
    if(newPrice.indexOf('.')>=0) {
      var splitprice = newPrice.split('.');
      if(splitprice.length>=2) {
        let firstDigit = splitprice[1].charAt(0);
        if(parseInt(firstDigit)>0) {
          digit = 1;
        }
        let secondDigit = splitprice[1].charAt(1);
        if(parseInt(secondDigit)>0) {
          digit = 2
        }
      }
     
    }
  }
  
  price = price !== "" ? parseFloat(price) : 0.0;

  var priceTxt =price.toFixed(digit)
  return priceTxt;
};

export const showStatus = function (status) {
  if (status === "A") {
    return <span className="btn btn-success">Active</span>;
  } else if (status === "I") {
    return <span className="btn btn-danger">InActive</span>;
  }
};

export const encodeValue = function (value) {
  if (value !== "") {
    return base64.encode(value);
  }
};
export const decodeValue = function (value) {
  if (value !== "") {
    return base64.decode(value);
  }
};

export const removeItem = function (
  formPayload,
  delUrl,
  sateValChange,
  currentPage
) {
  formPayload["userID"] = userID();
  Swal.fire({
    title: "Are you sure?",
    text: "You want remove this item!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    customClass: {
      confirmButton: "btn btn-primary me-3 waves-effect waves-light",
      cancelButton: "btn btn-label-secondary waves-effect",
    },
    buttonsStyling: false,
    showLoaderOnConfirm: true,
    preConfirm: () => {
      return Axios.post(
        apiUrl + delUrl,
        qs.stringify(formPayload),
        headerconfig
      ).then((res) => {
        return res.data;
      });
    },
    allowOutsideClick: () => !Swal.isLoading(),
  }).then((result) => {
    if (
      result?.value !== "" &&
      typeof result?.value !== undefined &&
      result?.dismiss !== "cancel"
    ) {
      if (result?.value?.status == "ok") {
        sateValChange("page", currentPage);
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: result.value.message,
          customClass: {
            confirmButton: "btn btn-success waves-effect",
          },
        });
      } else {
        Swal.fire({
          title: "Alert",
          text: result.value.message,
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger waves-effect",
          },
        });
      }
    }
  });
};
export const showDateTime = function (date) {
  if (date !== "" && typeof date !== undefined && typeof date !== "undefined") {
    return format(new Date(date), "MM/dd/yyyy hh:mm a");
  }
};
export const showDate = function (date) {
  if (date !== "" && typeof date !== undefined && typeof date !== "undefined") {
    return format(new Date(date), "MM/dd/yyyy");
  }
};

export const checkClientAuth = function (props) {
  var clientID = cookie.load("clientID") || "";
  if (clientID !== "") {
    props.history.push("/");
  }
};

export const isEmpty = function (value) {
  return value === "" ? "This field is required." : null;
};
export const isEmail = function (value) {
  if (value !== "" && value !== null) {
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    return value !== "" && value !== null && !pattern.test(value)
      ? "This is not a valid email."
      : null;
  } else {
    return null;
  }
};
export const isPhone = function (value) {
  var filter = /^[0-9-+]+$/;
  return value !== "" && value !== null && !filter.test(value)
    ? "This is not a valid phone."
    : null;
};
export const isNumber = function (value) {
  var regex = /^[0-9\s]*$/;
  return value !== "" && value !== null && !regex.test(value)
    ? "This is not a valid number."
    : null;
};
export const isSingleSelect = function (value) {
  console.log(value, 'valuevaluevaluevalue')
  if (value !== null) {
    return Object.keys(value).length > 0 ? null : "This field is required.";
  } else {
    return "This field is required.";
  }
};
export const isMultiSelect = function (value) {
  return value.length > 0 ? null : "This field is required.";
};

export const isValidPrice = function (value) {
  var regex = /^\d{0,8}(\.\d{1,4})?$/;
  return value !== "" && !regex.test(value)
    ? "This is not a valid price."
    : null;
};

export const userID = function () {
  return cookie.load("userID") || "";
};

export const checkPermission = function (moduleName, mType) {
  var userModule = cookie.load("userModule") || "";
  var userType = cookie.load("userType") || "";
  if (userType === "Admin") {
    return true;
  } else {
    if (userModule !== "") {
      var checkModule = userModule[moduleName] || "";
      if (checkModule !== "") {
        if (checkModule.indexOf(mType) >= 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
};


